import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { formatNumberThousands } from "../../../utils";

const InfoBoxSmall: React.FC = () => {
  const currentStakeAmount = useAppSelector(
    (state) => state.picks.currentStakeAmount
  );
  const { t } = useTranslation();

  return (
    <div className="info_box_container">
      <div className="info_box small">
        <div className="title">{t("panel.common.bet")}</div>
        <div className="box">
          {formatNumberThousands(currentStakeAmount, false)}
        </div>
      </div>
    </div>
  );
};

export default InfoBoxSmall;
